import { useTranslation } from 'react-i18next';

import { PomodoroMode, usePomodoroStore } from '@/apps/Pomodoro/stores/usePomodoroStore';
import { useAuthStore } from '@/common/stores/useAuthStore';

interface ModeControlsProps {
  widgetId: string;
  onClose: () => void;
}

export default function ModeControls({ onClose }: ModeControlsProps) {
  const { t } = useTranslation();
  const { mode, setMode } = usePomodoroStore();
  const { user } = useAuthStore();

  const handleModeChange = (newMode: PomodoroMode) => {
    setMode(newMode, user?.id);
    onClose();
  };

  return (
    <div className="p-4 flex flex-col gap-4">
      <h3 className="text-lg font-semibold text-gray-800">{t('pomodoro.timerSettings')}</h3>
      <div className="flex flex-col gap-3">
        <button
          className={`px-6 py-3 rounded-lg transition-all duration-200 ${
            mode === '25/5'
              ? 'bg-black text-white shadow-lg'
              : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
          }`}
          onClick={() => handleModeChange('25/5')}
        >
          <div className="text-left">
            <div className="font-medium">{t('pomodoro.mode25')}</div>
            <div className="text-xs opacity-80">{t('pomodoro.mode25Desc')}</div>
          </div>
        </button>
        <button
          className={`px-6 py-3 rounded-lg transition-all duration-200 ${
            mode === '50/10'
              ? 'bg-black text-white shadow-lg'
              : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
          }`}
          onClick={() => handleModeChange('50/10')}
        >
          <div className="text-left">
            <div className="font-medium">{t('pomodoro.mode50')}</div>
            <div className="text-xs opacity-80">{t('pomodoro.mode50Desc')}</div>
          </div>
        </button>
      </div>
      <button
        className="mt-2 px-4 py-2 text-sm text-gray-600 hover:bg-gray-100 rounded-lg transition-colors"
        onClick={onClose}
      >
        {t('common.cancel')}
      </button>
    </div>
  );
}
